import React from 'react';
import HomePageFlow from './Pages/Layout/HomePageFlow';
import EcomFlow from './Pages/Ecompage/EcomFlow';
import EcomCategoryFlow from './Pages/Ecompage/CategoryFlow';
import EcomInventoryFlow from './Pages/Ecompage/InventoryFlow';
import EcomDetailInventoryFlow from './Pages/Ecompage/DetailInventoryFlow';
import ManageInventoryFlow from './Pages/Ecompage/ManageInventoryFlow';
import AddEcomInventoryFlow from './Pages/Ecompage/EcomAddInventoryFlow';
import EditEcomInventoryFlow from './Pages/Ecompage/EditEcomInventoryFlow';
import IntrestedVendorFlow from './Pages/iterested/IntrestedVendorFlow';
import ProfileFlow from './Pages/Profile/profileFlow';
import EditProfileFlow from './Pages/Profile/editProfileFlow';

const PrivateRaoute = [
  //dashboard
  { path: "/dashboard", element: <HomePageFlow />, private: true },

  
  //profile
  { path: "/profile", element: <ProfileFlow />, private: true },
  { path: "/profile/editProfile", element: <EditProfileFlow />, private: true },

   //Ecom
   { path: "/ecom", element: <EcomFlow/>, private: true },
   { path: "/ecomcategory", element: <EcomCategoryFlow />, private: true },
   { path: "/ecominventory", element: <EcomInventoryFlow />, private: true },
   { path: "/ecominventorydetail", element: <EcomDetailInventoryFlow />, private: true },
 { path: '/manageInventory', element: <ManageInventoryFlow />, private: true },
 { path: '/EcomAddInventory', element: <AddEcomInventoryFlow />, private: true },
  { path: '/editEcomInventory', element: <EditEcomInventoryFlow />, private: true },

 
  //interestedVendor
  { path: '/interestedVendor', element: <IntrestedVendorFlow/>, private: true },

];

export default PrivateRaoute;
